export default "__VITE_ASSET__CKPuTHVl__"